import { render, staticRenderFns } from "./examArea.vue?vue&type=template&id=84cc4ace&scoped=true"
import script from "./examArea.vue?vue&type=script&lang=js"
export * from "./examArea.vue?vue&type=script&lang=js"
import style0 from "./examArea.vue?vue&type=style&index=0&id=84cc4ace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cc4ace",
  null
  
)

export default component.exports